import axiosClient from 'api/axiosClient';
import { useCallback } from 'react';

export default function useMarkNotificationRead() {
  const markNotificationAsRead = useCallback(async (notificationId: string): Promise<boolean> => {
    try {
      await axiosClient.patch('/notification/markNotificationAsRead', { notificationId });
      return true;
    } catch (error) {
      return false;
    }
  }, []);

  const markAllNotificationsAsRead = useCallback(async (): Promise<boolean> => {
    try {
      await axiosClient.patch('/notification/markAllNotificationsAsRead');
      return true;
    } catch (error) {
      return false;
    }
  }, []);

  return { markNotificationAsRead, markAllNotificationsAsRead };
}
